import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { CheckboxChangeEventDetail, NavController } from '@ionic/angular';
import { ActiveLink, SidebarLink } from '../category-sidebar-wrapper/service/category-sidebar.service';
import { encodeQueryParam } from 'src/helpers';

@Component({
  selector: 'app-category-sidebar-menu-item',
  templateUrl: './category-sidebar-menu-item.component.html',
  styleUrls: ['./category-sidebar-menu-item.component.scss'],
})
export class CategorySidebarMenuItemComponent implements OnInit {
  @Input() mode: 'single' | 'multiple' = 'single';
  @Input() sidebarLink: SidebarLink;
  @Input() activeLinkIds: ActiveLink[];
  @Input() accordionBranchOrder = 0;
  @Output() checkCategory = new EventEmitter<{ checked: boolean; sidebarLink: SidebarLink }>();

  constructor(private navController: NavController) {}

  ngOnInit() {}

  matchWithSomeActiveLinks(linkId: number) {
    return this.activeLinkIds.some(link => link.id === linkId);
  }

  async navigateToCategory(categoryLink: SidebarLink) {
    await this.navController.navigateForward(`/category-detail/${categoryLink.id}`);
  }

  checkCategoryHandler(event: Event, sidebarLink: SidebarLink) {
    const customEvent = event as CustomEvent<CheckboxChangeEventDetail>;
    const value = customEvent.detail.checked;
    this.checkCategory.emit({ checked: value, sidebarLink });
  }

  checkSubcategoryHandler(event: { checked: boolean; sidebarLink: SidebarLink }) {
    this.checkCategory.emit(event);
  }

  async navigateToSubCategory(subcategoryLink: SidebarLink) {
    await this.navController.navigateForward(`/subcategory-detail/${subcategoryLink.id}`, {
      queryParams: {
        category_name: encodeQueryParam(subcategoryLink.name),
        tags: encodeQueryParam(subcategoryLink.tags),
      },
    });
  }
}
